import {pushEvent} from "tracking/core/dispatcher";
import {EVENT_NAMES} from "tracking/core/eventNames";
import {AccordionPayload, PushOptions} from "tracking/core/types";

export type AccordionInput =
    | string
    | { title?: string | null; teaserTitle?: string | null }
    | null
    | undefined;

export function toAccordionPayload(input?: AccordionInput): AccordionPayload {
    const content_label =
        typeof input === "string" ? input : input?.title ?? input?.teaserTitle ?? undefined;

    return {
        content_label,
    };
}

export function toAccordionEvent(input?: AccordionInput, isExpanded?: boolean) {
    const name = isExpanded ? EVENT_NAMES.ACCORDION_EXPAND : EVENT_NAMES.ACCORDION_COLLAPSE;
    return {name, payload: toAccordionPayload(input)} as const;
}

export function trackAccordionToggle(input?: AccordionInput, isExpanded?: boolean,
                                     options?: PushOptions) {
    const {name, payload} = toAccordionEvent(input, isExpanded);
    return pushEvent(name, payload, options);
}
